










import Vue from "vue";

// Vue components
import AppPage from "@/components/AppPage.vue";
import FiltersCard from "./FiltersCard.vue";
import MainTable from "./MainTable.vue";

// Model
import * as routes from "@/router/routes";
import { GetFitnessStatisticsReportCommand } from "@/model/communication/fitnessStatistics/GetFitnessStatisticsReportCommand";
import { GetFitnessStatisticsReportReqData } from "@/model/communication/fitnessStatistics/GetFitnessStatisticsReportReqData";
import { GetFitnessStatisticsReportResData } from "@/model/communication/fitnessStatistics/GetFitnessStatisticsReportResData";
import { DownloadFitnessStatisticsReportCommand } from "@/model/communication/fitnessStatistics/DownloadFitnessStatisticsReportCommand";
import { DownloadFitnessStatisticsReportReqData } from "@/model/communication/fitnessStatistics/DownloadFitnessStatisticsReportReqData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { SourceDestEnum } from "@/model/data/fitnessStatistics/SourceDestEnum";
import { FitnessStatisticsTotals } from "@/model/data/fitnessStatistics/FitnessStatisticsTotals";

export default Vue.extend({
    components: {
        AppPage,
        FiltersCard,
        MainTable,
    },
    data() {
        return {
            routes,
            loading: false,
            statisticsGroupBySourceDest: null,
            tempStatisticsGroupBySourceDest: null,
            currentReqData: null,
            error: false,
            confExists: false,
        };
    },
    computed: {
        menuRoutes() {
            return this.$store.getters.availableMenu;
        },

        styleProps() {
            let found = false;
            let resultObj = { icon: null, title: null, color: null };

            let findIconColorAndTitle: Function = (node: any) => {
                if (!found) {
                    if (node.children && node.children.length > 0) {
                        node.children.forEach((child) => {
                            findIconColorAndTitle(child);
                        });
                    } else if (node.path == this.routes.StatisticsReport) {
                        resultObj.icon = node.icon;
                        resultObj.title = this.$t(node.name_i18n);
                        resultObj.color = node.color;
                        found = true;
                    }
                }
            };

            this.menuRoutes.forEach((route) => {
                findIconColorAndTitle(route);
            });

            return resultObj;
        },

        icon() {
            return this.styleProps.icon ? this.styleProps.icon : "";
        },

        title() {
            return this.styleProps.title ? this.styleProps.title : "";
        },

        color() {
            return this.styleProps.color ? this.styleProps.color : "";
        },

        statisticsList() {
            let res = [];

            //Iterate over map keys
            if (this.statisticsGroupBySourceDest != null) {
                for (let key of this.statisticsGroupBySourceDest.keys()) res.push({ sourceDest: SourceDestEnum[key], ...this.statisticsGroupBySourceDest.get(key) });
            }

            return res;
        },
    },
    methods: {
        async sendRequest(request) {
            try {
                this.loading = true;

                let reqData: GetFitnessStatisticsReportReqData = new GetFitnessStatisticsReportReqData();
                reqData.year = request.year;
                reqData.semester = request.semester;
                reqData.branchId = request.branchId;

                this.currentReqData = { ...request };

                // se ho selezionato delle installazioni specifiche faccio una chiamata per ogni installazione poi aggrego
                if (request.installationNames != null && request.installationNames.length > 0) {
                    this.tempStatisticsGroupBySourceDest = new Map<SourceDestEnum, FitnessStatisticsTotals>();

                    let promises = [];
                    request.installationNames.forEach(async (installationName) => {
                        reqData.installationName = installationName;
                        promises.push(this.singleInstallationRequest(reqData));
                    });

                    await Promise.all(promises).then(() => {
                        this.statisticsGroupBySourceDest = this.tempStatisticsGroupBySourceDest;
                        this.loading = false;
                    });
                } else {
                    reqData.installationName = "";
                    let response: GetFitnessStatisticsReportResData = await new GetFitnessStatisticsReportCommand(reqData).execute();
                    if (response.responseStatus == ApiResponseStatusEnum.Success) {
                        this.statisticsGroupBySourceDest = response.statisticsGroupBySourceDest;
                        this.confExists = response.confExists;
                    }
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong sending GetFitnessStatisticsReport request ", e);
                this.loading = false;
            }
        },

        async singleInstallationRequest(reqData: GetFitnessStatisticsReportReqData) {
            let response: GetFitnessStatisticsReportResData = await new GetFitnessStatisticsReportCommand(reqData).execute();

            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.confExists = response.confExists;
                for (let key of response.statisticsGroupBySourceDest.keys()) {
                    // se è già presente una sourceDest allora vado a sommare i FitnessStatisticsTotals
                    if (this.tempStatisticsGroupBySourceDest.has(key)) {
                        (this.tempStatisticsGroupBySourceDest.get(key) as FitnessStatisticsTotals).sumFitnessStatisticsTotals(response.statisticsGroupBySourceDest.get(key));
                    } else this.tempStatisticsGroupBySourceDest.set(key, response.statisticsGroupBySourceDest.get(key));
                }
            }
        },

        async onDownload(downloadRequest) {
            let exportType = downloadRequest.exportType;
            console.log("Download required, exportType: ", exportType);

            if (!this.loading) {
                this.loading = true;
                try {
                    let downloadReqData: DownloadFitnessStatisticsReportReqData = new DownloadFitnessStatisticsReportReqData();
                    downloadReqData.year = this.currentReqData.year;
                    downloadReqData.semester = this.currentReqData.semester;
                    downloadReqData.branchId = this.currentReqData.branchId;
                    downloadReqData.installationNames = this.currentReqData.installationNames;
                    downloadReqData.glnReporter = downloadRequest.glnReporter;
                    downloadReqData.glnOwner = downloadRequest.glnOwner;
                    downloadReqData.fromConf = downloadRequest.fromConf;
                    downloadReqData.mode = downloadRequest.mode;
                    const res = await new DownloadFitnessStatisticsReportCommand(downloadReqData, exportType).execute();
                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                    this.error = false;
                } catch (e) {
                    console.log("Something went wrong during DownloadFitnessStatisticsReportCommand execution: ", e);
                    this.loading = false;
                    this.error = true;
                }
            }
        },
    },
});
